import {DatePipe} from '@angular/common';
import {CHECKED_VALUES} from 'src/app/domain/command/command.command';
import {UpdateLeadDataCommand} from 'src/app/domain/command/lead/UpdateLeadDataCommand';
import {uuid} from 'src/app/domain/function/uuid.helper';
import {Lead} from 'src/app/domain/model/lead/lead.model';
import {UserFixture} from 'src/app/domain/model/user/user-fixture.model';
import {getZipCodeFormatted} from 'src/app/domain/service/api/fixtures.api';

export const createLeadDataFromLead = (lead: Lead): UpdateLeadDataCommand => {
  let secondSurname = '';
  const surnameList = lead?.profile.surname?.split(' ') || [];
  if (surnameList.length > 1) {
    secondSurname = surnameList.pop();
  }
  const firstSurname = surnameList.join(' ');

  const command = {
    commandId: uuid(),
    name: lead?.profile.name,
    firstSurname,
    secondSurname,
    noSecondSurname: lead?.profile.hasSecondSurname === false ? CHECKED_VALUES.on : CHECKED_VALUES.off,
    children: lead?.profile.numberOfChildren,
    maritalStatus: lead?.profile.maritalStatus,
    maritalRegime: lead?.profile.maritalRegime,
    activity: lead?.profile.activity,
    employmentStatus: lead?.profile.employmentStatus,
    incomeVolume: lead?.profile.incomeVolume,
    incomeOrigin: lead?.profile.incomeOrigin,
    taxObligationsInAnotherCountry: lead?.profile.taxObligationsInAnotherCountry,
    fundsOrigin: lead?.planSettings.fundsOrigin,
    publicCharge: lead?.profile.publicCharge,
    publicChargeKind: lead?.profile.publicChargeKind,
    taxLiabilityCountry1: lead?.profile.taxLiabilities?.length > 0 ? lead.profile.taxLiabilities[0].country : '',
    taxLiabilityCountry2: lead?.profile.taxLiabilities?.length > 1 ? lead.profile.taxLiabilities[1].country : '',
    taxLiabilityCountry3: lead?.profile.taxLiabilities?.length > 2 ? lead.profile.taxLiabilities[2].country : '',
    taxLiabilityVat1: lead?.profile.taxLiabilities?.length > 0 ? lead.profile.taxLiabilities[0].vat : '',
    taxLiabilityVat2: lead?.profile.taxLiabilities?.length > 1 ? lead.profile.taxLiabilities[1].vat : '',
    taxLiabilityVat3: lead?.profile.taxLiabilities?.length > 2 ? lead.profile.taxLiabilities[2].vat : '',
    vat: lead?.profile.vat,
    birthdate: lead?.profile.birthdate ? lead.profile.birthdate.replace('-', '/').replace('-', '/') : null,
    cityOfBirth: lead?.profile.cityOfBirth,
    countryOfBirth: lead?.profile.countryOfBirth,
    nationality1: lead?.profile.nationalities?.length > 0 ? lead.profile.nationalities[0].country : '',
    nationality2: lead?.profile.nationalities?.length > 1 ? lead.profile.nationalities[1].country : '',
    nationality3: lead?.profile.nationalities?.length > 2 ? lead.profile.nationalities[2].country : '',
    gender: lead?.profile.sex,
    country: lead?.profile.address?.country,
    postalStreetType: lead?.profile.address?.postalStreetType,
    postalStreet: lead?.profile.address?.postalStreet,
    postalStreetNumber: lead?.profile.address?.postalStreetNumber,
    postalExtraData: lead?.profile.address?.postalExtraData,
    state: lead?.profile.address?.state,
    city: lead?.profile.address?.city,
    zip: lead?.profile.address?.zipCode,
    isCompanyManager: null
  };

  return command;
};

export const createLeadDataFromFixture = (userFixture: UserFixture, additionalParams?: any): UpdateLeadDataCommand => {
  let secondSurname = '';
  const surnameList = userFixture?.name.last?.split(' ') || [];
  if (surnameList.length > 1) {
    secondSurname = surnameList.pop();
  }
  const firstSurname = surnameList.join(' ');

  const command: UpdateLeadDataCommand = {
    commandId: uuid(),
    name: userFixture?.name.first,
    firstSurname,
    secondSurname,
    noSecondSurname: userFixture?.name.last ? CHECKED_VALUES.off : CHECKED_VALUES.on,
    children: null,
    maritalStatus: null,
    maritalRegime: null,
    employmentStatus: null,
    incomeVolume: null,
    incomeOrigin: null,
    taxObligationsInAnotherCountry: false,
    fundsOrigin: null,
    publicCharge: null,
    publicChargeKind: null,
    taxLiabilityCountry1: '',
    taxLiabilityCountry2: '',
    taxLiabilityCountry3: '',
    taxLiabilityVat1: '',
    taxLiabilityVat2: '',
    taxLiabilityVat3: '',
    vat: '',
    birthdate: new DatePipe(navigator.language).transform(new Date(userFixture?.dob.date), 'yyyy-MM-dd') ?? null,
    cityOfBirth: userFixture?.location.city,
    nationality1: userFixture?.nat,
    nationality2: '',
    nationality3: '',
    gender: userFixture?.gender,
    country: userFixture?.location.country,
    postalStreetType: 'Calle',
    postalStreet: userFixture?.location.street.name,
    postalStreetNumber: userFixture?.location.street.number,
    postalExtraData: '',
    state: userFixture?.location.state,
    city: userFixture?.location.city,
    zip: getZipCodeFormatted(userFixture?.location.postcode),
    ...additionalParams
  };

  return command;
};
